import React from "react";
import Loader from "./Loader";

// If a crash happens twice within this window, auto-reload didn't help —
// stop reloading (avoid an infinite refresh loop) and just sit on the
// loader instead of looping forever.
const RELOAD_GUARD_KEY = "__eb_reload_guard";
const RELOAD_GUARD_WINDOW_MS = 10000;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary] Uncaught render error:", error, errorInfo);

    let guard = null;
    try {
      guard = JSON.parse(sessionStorage.getItem(RELOAD_GUARD_KEY) || "null");
    } catch {
      guard = null;
    }

    const now = Date.now();
    const recentlyReloaded =
      guard && now - guard.time < RELOAD_GUARD_WINDOW_MS;

    if (!recentlyReloaded) {
      try {
        sessionStorage.setItem(RELOAD_GUARD_KEY, JSON.stringify({ time: now }));
      } catch {}
      window.location.reload();
    }
    // else: crashed again right after a reload — stop auto-reloading and
    // just render the loader below instead of refreshing forever.
  }

  render() {
    if (this.state.hasError) {
      // No error text shown — either a reload is about to happen, or we've
      // already tried that once and stopped, but either way the user only
      // ever sees a normal-looking loading state, never an error message.
      return <Loader loading />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
